import { useEffect, useState } from "react";
import HeroSection from "../components/HeroSection.jsx";
import { getBlocks } from "../services/utils.jsx";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";

const Home = () => {
    const [blocks, setBlocks] = useState([]);
    const [transactions, setTransactions] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getBlocks();
                setBlocks(response?.blocks);
                setTransactions(response?.tx);
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, []);

    function timeAgo(timestamp) {
        const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
        const secondsAgo = currentTime - timestamp;

        // Define time intervals in seconds
        const intervals = [
            { label: "year", seconds: 31536000 },
            { label: "month", seconds: 2592000 },
            { label: "day", seconds: 86400 },
            { label: "hour", seconds: 3600 },
            { label: "minute", seconds: 60 },
        ];

        // Find the appropriate time interval
        for (const interval of intervals) {
            const intervalCount = Math.floor(secondsAgo / interval.seconds);
            if (intervalCount >= 1) {
                return intervalCount > 1
                    ? `${intervalCount} ${interval.label}s ago`
                    : `${intervalCount} ${interval.label} ago`;
            }
        }

        // If less than a minute ago
        return "Just now";
    }
    return (
        <>
            <div className="h-screen w-screen">
                <HeroSection />
                <div className="flex justify-center gap-10 px-10 mt-10">
                    {/* Latest Blocks */}
                    <table class="w-[50%] text-sm text-left rtl:text-right text-gray-500 border border-1 border-gray-100 rounded-lg">
                        <thead class="text-xs text-gray-700 uppercase bg-gray-50">
                            <tr>
                                <th scope="col" class="px-6 py-3">
                                    Latest Blocks
                                </th>
                                <th scope="col" class="px-6 py-3"></th>
                                <th scope="col" class="px-6 py-3"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {blocks.length === 0 ? (
                                <tr>
                                    <td colSpan="3">
                                        <Skeleton count={10} />
                                    </td>
                                </tr>
                            ) : (
                                blocks.map((el, index) => (
                                    <tr
                                        className="odd:bg-white even:bg-gray-50 border-b"
                                        key={index}
                                    >
                                        <td
                                            scope="row"
                                            className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap"
                                        >
                                            <Link to={`/block/${el.number}`}>
                                                <p className="text-blue-400 hover:underline">
                                                    {el.number}
                                                </p>
                                            </Link>
                                            <p>{timeAgo(el.timestamp)}</p>
                                        </td>
                                        <td
                                            scope="row"
                                            className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap"
                                        >
                                            <div className="flex gap-3">
                                                <p>Fee Recipient</p>
                                                <p className="text-blue-400 hover:underline">
                                                    {el?.miner?.slice(0, 7)}...
                                                    {el?.miner?.slice(-7)}
                                                </p>
                                            </div>
                                            <p>{el.transactions.length}</p>
                                        </td>
                                        <td
                                            scope="row"
                                            className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap"
                                        ></td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                    {/* Latest Transactions */}
                    <table class="w-[50%] text-sm text-left rtl:text-right text-gray-500 border border-1 border-gray-100 rounded-lg">
                        <thead class="text-xs text-gray-700 uppercase bg-gray-50">
                            <tr>
                                <th scope="col" class="px-6 py-3">
                                    Latest Transactions
                                </th>
                                <th scope="col" class="px-6 py-3"></th>
                                <th scope="col" class="px-6 py-3"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {blocks.length === 0 ? (
                                <tr>
                                    <td colSpan="3">
                                        <Skeleton count={10} />
                                    </td>
                                </tr>
                            ) : (
                                transactions?.map((el, index) => (
                                    <tr
                                        className="odd:bg-white even:bg-gray-50 border-b"
                                        key={index}
                                    >
                                        <td
                                            scope="row"
                                            className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap"
                                        >
                                            <Link to={`/tx/${el.hash}`}>
                                                <p className="text-blue-400 hover:underline">
                                                    {el?.hash?.slice(0, 14)}...
                                                </p>
                                            </Link>
                                            {/* Uncomment if needed */}
                                            {/* <p>{timeAgo(el.timestamp)}</p> */}
                                        </td>
                                        <td
                                            scope="row"
                                            className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap"
                                        >
                                            <div className="flex gap-3">
                                                <Link
                                                    to={`/wallet/${el.from}`}
                                                    className="flex gap-3"
                                                >
                                                    <p>From</p>
                                                    <p className="text-blue-400 hover:underline">
                                                        {el?.from?.slice(0, 7)}
                                                        ...{el?.from?.slice(-7)}
                                                    </p>
                                                </Link>
                                                <Link
                                                    to={`/wallet/${el.to}`}
                                                    className="flex gap-3"
                                                >
                                                    <p>To</p>
                                                    <p className="text-blue-400 hover:underline">
                                                        {el?.to?.slice(0, 7)}...
                                                        {el?.to?.slice(-7)}
                                                    </p>
                                                </Link>
                                            </div>
                                        </td>
                                        <td
                                            scope="row"
                                            className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap"
                                        ></td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default Home;
